import Image from "gatsby-image";
import React from "react";
import OgImage from "../../../../assets/images/blog/article_18/og.png";
import {useAuthorsData} from "../../Authors/useAuthorsData";
import {ArticlePhotos} from "./ArticlePhotos";

export const ArticleData = () => {
  const images = ArticlePhotos();
  const authors = useAuthorsData();

  return {
    date:      "14.06.2022r",
    category:  "content marketing, archetypy",
    title:     <>Jak zbudować osobowość marki? Poznaj 12 archetypów!</>,
    SEO_title: "Jak zbudować osobowość marki? Poznaj 12 archetypów!",
    description:
               <>
                 Czy archetypy marki to skuteczny sposób na kreowanie wymarzonego wizerunku? Na to pytanie odpowie Ci Twórca, Władca, Opiekun, Niewinny, Mędrzec, Odkrywca, Buntownik, Magik, Bohater, Towarzysz, Dusza Towarzystwa i Kochanek. Poznaj 12 typów osobowości marki, które ułatwią komunikację z Twoimi klientami.
               </>,
    seo:       "Poznaj 12 typów osobowości marki, które ułatwią komunikację z Twoimi klientami.",
    slug:      "/blog/jak-zbudowac-osobowosc-marki-poznaj-12-archetypow",
    image:     OgImage,
    authors:   [
      authors.JustynaBak,
    ],
    hero:      (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.hero.childImageSharp.fluid}
                 />
               ),
    text:      {
      first:  {
        title: "",
        text:  <>
                 1 kwietnia 1976 roku powstała firma, której założyciele postanowili sprzedawać komputery. Pomimo tego, że początkowo biznes nie szedł po ich myśli, to już na początku lat 80. w USA zaczynały się one cieszyć coraz większą popularnością, a zyski firmy stale rosły. Postawiono na innowację, której brakowało w ówczesnych czasach. Przekształcono wizję w materię. Kreowano rzeczywistość, jednocześnie wyrażając siebie. Takim podejściem zjednano do siebie miliony ludzi na całym świecie, a nazwisko Steve’a Jobsa i jego marki Apple jest obecnie znane każdemu. Dlaczego? Stała za tym m.in. perfekcyjnie zaplanowana strategia marketingowa. Oparta na konkretnym modelu - archetypie - który pomógł jej założycielom w osiągnięciu niepodważalnego sukcesu.
               </>,
      },
      second: {
        title: "Czym są archetypy w marketingu?",
        text:  <>
                 Archetyp marki - co to właściwie jest? To reprezentant danej marki, jej cech, celów i wyobrażeń. To sposób komunikacji z jej odbiorcami. To przewodnik po obranej strategii marketingowej.
                 <br/>
                 <br/>
                 Pojęcie archetypu wprowadził Carl Gustav Jung - szwajcarski psychiatra - który badając sny, urojenia czy fantazje, zauważył, że niezależnie od indywidualnych doświadczeń swoich pacjentów, pojawiają się w nich podobne wyobrażenia i motywy, powtarzane od wielu pokoleń. I tak w 1919 roku powstało pojęcie archetypu, czyli modelu, wzorca, który opisuje daną sytuację, zjawisko czy postać. Jak to się ma do marketingu? Archetypy pomagają w tworzeniu spójności marki, określenia jej charakteru i jasnej komunikacji z odbiorcami.
                 <br/>
                 <br/>
                 Przeczytaj także: Przepis na sukces, czyli co to jest <a href="https://interactivevision.pl/blog/przepis-na-sukces-czyli-co-to-jest-strategia-marketingowa">strategia marketingowa </a>
               </>
      },

      third:      {
        title: "Opiekun, Mędrzec, a może Towarzysz?",
        text:  <>
                 Obecnie rozróżnia się 12 archetypów marki. Klasyfikacji tej dokonały Margaret Mark i Carol Pearson, które dodatkowo podzieliły je na 4 grupy według odpowiadających im wspólnym cechom. Cechy te odnoszą się do potrzeb konsumentów, które mają zaspokoić oferowane produkty czy usługi.
               </>
      },
      fourth:     {
        title: "Bezpieczeństwo, stabilizacja, kontrola",
        text:  <>
                 <strong>Creator (Twórca, Odkrywca)</strong> buduje własną rzeczywistość i pomaga w jej tworzeniu swoim klientom. Chce mieć na nią wpływ, co daje mu poczucie kontroli i przyjemności. Nie zależy mu na tym, aby się wpasować. Woli wyrażać siebie, nie idąc przy tym na kompromisy. Swoją artystyczną duszę łączy z przedsiębiorczością i innowacją. Jego cel to wdrożenie własnej wizji w życie.
                 <br/>
                 <br/>
                 Marki zgodne z archetypem Twórcy oferują często różnorodność i duży wybór. Stawiają na kreatywność i rozwijanie jej wśród swoich klientów. Są innowacyjne. Wprowadzają na rynek nowe produkty lub usługi, które pomagają innym w rozwoju.
                 <br/>
                 <br/>
                 Przykład: Lego
               </>
      },
      fifth:      {
        title: null,
        text:  <>
                 <strong>Ruler (Władca)</strong> chce stworzyć dobrze prosperującą organizację, która będzie stabilna i którą będzie można w skuteczny sposób kontrolować. Dąży do przywództwa, a gdy je osiągnie, bierze za nie pełną odpowiedzialność. Nie jest jednak odbierany jako zadufany w sobie. Swoich klientów obdarza lojalnością i ochroną, a ponadto jest odpowiedzialny i stabilny. Dużo analizuje, bardzo dba o klienta i jego interesy. Skupia wokół siebie solidnych ludzi - społeczność - którą pociągnie za sobą i podobnie jak on będzie odnosić sukces.
                 <br/>
                 <br/>
                 Marka o archetypie tym skupia się głównie na przewodzeniu, kierowaniu, odpowiedzialności, zapewnieniu porządku i ładu. Władca przejmuje kontrolę, tworząc porządek z chaosu, dlatego marki o tym archetypie są doskonale zorganizowane.
                 <br/>
                 <br/>
                 Przykład: Rolex
               </>
      },
      sixth:      {
        title: null,
        text:  <>
                 <strong>Caregiver (Opiekun)</strong> jest altruistą. Chce pomagać innym, ponieważ bliskie mu są rodzicielskie uczucia i instynkty. Jest gotowy do poświęceń. Nie tylko sam troszczy się o innych, ale też pomaga do tego dążyć.
                 <br/>
                 <br/>
                 Kreowanie wizerunku marki zgodnej z archetypem Opiekuna wymaga zachowania autentyczności w komunikacji opartej na empatii i altruizmie. Takie firmy troszczą się o swoich odbiorców, chcą zapewnić im bezpieczeństwo i pomóc w dążeniu do celu. Charakteryzuje je ciepło, łagodność, troskliwość i serdeczność.
                 <br/>
                 <br/>
                 Przykład: Nivea
               </>
      },
      seventh:    {
        title: "Niezależność, spełnienie",
        text:  <>
                 <strong>Innocent (Niewinny, Marzyciel)</strong> pokazuje wszystkim, że świat jest pięknym miejscem, w którym wszystko jest możliwe. Jest sentymentalny. Biją od niego tylko pozytywne emocje, które udzielają się jego odbiorcom. Sprawia, że osoby w jego otoczeniu czują się przez to bezpiecznie i są szczęśliwe. Kierują się uczciwością, a więzi ze swoimi klientami opierają na wzajemnym zaufaniu.
                 <br/>
                 <br/>
                 W swojej komunikacja marka Niewinny stawia na prosty przekaz. Często nawiązuje do przeszłości, którą konfrontuje ze współczesnością. Zachęca, by cieszyć się z każdej chwili.
                 <br/>
                 <br/>
                 Przykład: Coca-Cola
               </>
      },
      eight:      {
        title: null,
        text:  <>
                 <strong>Sage (Mędrzec, Filozof)</strong> kieruje się jedynie faktami. Jest inteligentny. Dokładnie sprawdza każdą wiadomość, zanim poda ją dalej. Interesują go wyniki badań, statystyki, liczby. Traktuje je jako wiarygodne źródło wiedzy. Zależy mu, by być autorytetem dla swoich odbiorców. Chce im pomagać w zrozumieniu otaczającego świata.

                 <br/>
                 <br/>
                 Marki, które chcą kreować swój wizerunek, opierając się na archetypie Mędrca, najczęściej mają już ugruntowaną pozycję. Klienci darzą je zaufaniem, a informacje, które podają, uznają za niewymagające sprawdzania.

                 W swojej komunikacja marka Niewinny stawia na prosty przekaz. Często nawiązuje do przeszłości, którą konfrontuje ze współczesnością. Zachęca, by cieszyć się z każdej chwili.
                 <br/>
                 <br/>
                 Przykład: Google

               </>
      },
      ninth:      {
        title: null,
        text:  <>
                 <strong>Seeker (Odkrywca)</strong> kocha przygody. Nie uznaje ograniczeń, pragnie być wolny i niezależny. Chce sprawiać, by życie jego odbiorców było ciekawsze i inspirować ich do poznawania tego, co nieznane. Zachęca do wychodzenia z własnej strefy komfortu.
                 <br/>
                 <br/>
                 Archetyp Odkrywcy będzie odpowiedni dla marek, dla których nie ma ograniczeń i do tego samego chcą przekonać swoich odbiorców. Chętnie podejmują różne wyzwania, dzielą się swoim doświadczeniem. Nie chcą jednak niczego nikomu udowadniać.
                 <br/>
                 <br/>
                 Przykład: GoPro
               </>
      },
      tenth:      {
        title: "Osiągnięcia, zmiany, podejmowanie ryzyka",
        text:  <>
                 <strong>Outlaw (Buntownik)</strong> nie zgadza się z obecną sytuacją. Chce ją zmienić, obalić stereotypy, bo przede wszystkim ceni sobie wolność. Głośno mówi o swoich wartościach i nie boi się wyrażać swoich poglądów. Tematy tabu dla niego nie istnieją. Zwraca również uwagę na współczesne problemy społeczeństwa. Wie, co chce osiągnąć i stale do tego dąży.
                 <br/>
                 <br/>
                 Archetyp Buntownika sprawdzi się wśród marek, które wprowadzają na rynek rewolucyjne produkty czy usługi. Marki te nie boją się wyrażać swojego zdania, nawet jeśli nie zawsze jest to łatwe. Chętnie również wypowiadają się na kontrowersyjne tematy.
                 <br/>
                 <br/>
                 Przykład: Netflix
               </>
      },
      eleventh:   {
        title: "",
        text:  <>
                 <strong>Magician (Magik, Czarodziej)</strong> kieruje się podobnymi wartościami co Niewinny, jednak wprowadza do życia magię. Wprowadza zmiany, jednak nie poprzez rewolucję czy walkę, a dzięki… czarom! Właściwie nikt nie wie, jak tego dokonuje, ale efekty jego działań jednoczą wokół niego wiele osób.
                 <br/>
                 <br/>
                 Marka zgodna z archetypem Magika pomaga innym dokonywać transformacji i zmieniać znaną im rzeczywistość. Nie pokazuje etapów swojej pracy, nie wyjaśnia procesu tworzenia, a daje gotowy produkt. Marki te cechuje charyzma.
                 <br/>
                 <br/>
                 Przykład: Mr Clean
               </>
      },
      twelfth:    {
        title: null,
        text:  <>
                 <strong>Warrior (Bohater, Wojownik)</strong> za cel stawia sobie walkę z przeciwnościami losu. Jest skoncentrowany na osiągnięciu swoich założeń. Jego mocną stroną jest skuteczność. Wie, co zrobić, by osiągnąć sukces i stale do tego dąży. Walczy przede wszystkim z przeciwnościami losu, co pokazuje swoim klientom.
                 <br/>
                 <br/>
                 Marki, które prowadzą swoją komunikację zgodnie z archetypem Bohatera, zachęcają swoich odbiorców do pokonywania własnych granic i pracowania nad sobą, by stawać się najlepszą wersją siebie. Chcą im to ułatwić poprzez swoje produkty czy usługi.
                 <br/>
                 <br/>
                 Przykład: Nike
               </>
      },
      thirteenth: {
        title: "Przynależność do grupy, zadowolenie",
        text:  <>
                 <strong>Everyman (Towarzysz, Zwykły Człowiek)</strong> chce po prostu być sobą. Nie oczekuje zbyt wiele, byle tylko mieć wokół siebie kilku życzliwych ludzi. Dla swoich klientów jest najlepszym przyjacielem. Nie lubi wyróżniać się z tłumu, chce być w grupie. Jest bardzo przyjazny, szybko nawiązuje relacje i zdobywa zaufanie odbiorców. Traktuje wszystkich tak samo, ponieważ uważa, że każdy jest równy. Jest pokorny i nie wstydzi pokazywać się prawdziwego życia.
                 <br/>
                 <br/>
                 Archetyp Towarzysza jest dobry dla marek, które reprezentują produkty codziennego użytku o niewygórowanych cenach. Nie chcą szokować, a udowadniać, że ich produkty są przede wszystkim bezpieczne i przydatne. Po prostu są potrzebne każdego dnia, rozwiązując codzienne problemy.
                 <br/>
                 <br/>
                 Przykład: IKEA
               </>
      },
      fourteenth: {
        title: null,
        text:  <>
                 <strong>Jester (Dusza Towarzystwa, Wesołek, Błazen)</strong> uwielbia żartować. Jednak jego żarty mają głębszy sens. Dzięki nim pokazuje swoją wizję rzeczywistości, która polega na czerpaniu radości z życia. Nie ironizuje i nie wyśmiewa innych. Jest życzliwy. Pomimo że jego codzienność to zawsze dobry humor, potrafi również wypowiadać się na trudne tematy.
                 <br/>
                 <br/>
                 Marki posługujące się archetypem Duszy Towarzystwa wykorzystują humor w swojej komunikacji. Tworzą memy, chcą się dobrze bawić. Swoje produkty lub usługi prezentują w zabawny sposób. Ich komunikacja jest łatwa w odbiorze.
                 <br/>
                 <br/>
                 Przykład: Skittles
               </>
      },
      fifteenth:  {
        title: null,
        text:  <>
                 <strong>Lover (Kochanek, Wielbiciel)</strong> pragnie być pożądany. Chce być uwielbiany przez wszystkich i dawać niezapomniane doświadczenia. Nawiązuje do miłości, rozkoszy i namiętności. Jednak nie ogranicza się jedynie do romansu. Odnosi się również do miłości rodzicielskiej czy przyjacielskiej.
                 <br/>
                 <br/>
                 Komunikacja marki Kochanka odwołuje się do zmysłów. Swoim klientom daje poczucie przyjemności i intymności. Pokazuje bliskość i uczucia, które wiążą się z osobistymi relacjami.
                 <br/>
                 <br/>
                 Przykład: Chanel
               </>
      },
      sixteenth:  {
        title: "Jak znaleźć swój archetyp?",
        text:  <>
                 Archetypy marki w marketingu są niezwykle pomocne, pod warunkiem, że wiesz, jak je wykorzystać. Nie wystarczy wybrać konkretnego modelu i czekać na efekty. To proces, który wymaga czasu i konsekwentnych działań.
                 <br/>
                 <br/>
                 Często zdarza się tak, że kilka archetypów pasuje do jednej marki. I nie jest to nic dziwnego. Archetypy można ze sobą łączyć, pod warunkiem, że wzajemnie się nie wykluczają. Przez lata mogą się też one przekształcić w inny model. W końcu jedyną stałą rzeczą w życiu jest zmiana. Takim przykładem jest wspomniana już marka Apple. Kiedy pojawiła się na rynku, identyfikowała się z archetypem Buntownika - rewolucyjny produkt, który wiele zmienił w branży technologicznej. A obecnie? Bliżej jej do Twórcy, który stale wprowadza nowe, innowacyjne produkty, pozwalające innym tworzyć wszystko, co sprawi, że poczują się dobrze.
                 <br/>
                 <br/>
                 Jeśli jesteś na etapie tworzenia własnej marki lub jeśli Twoja strategia marketingowa jest z jakiegoś powodu nieskuteczna, możemy Ci pomóc! Wspólnie wybierzemy najlepszą ścieżkę rozwoju Twojej firmy.
               </>
      }
    },

    list:              {
      first: {
        title:   "Pamiętaj o tym, żeby:",
        text:    "",
        content: [
          <><strong>Nie oceniać influencera na podstawie ilości obserwujących.</strong> <br/> Szerokie zasięgi nie zawsze idą w parze z interesującym contentem i&nbsp;aktywną społecznością. Zamiast liczby followersów sprawdź zaangażowanie pod postami. </>,
          <><strong>Szukać influencerów podzielających wartości Twojej firmy.</strong> <br/>Jeśli zależy Ci na autentycznym przekazie, zadbaj o to, by z&nbsp;marką utożsamiała się osoba o podobnych poglądach.</>,
          <><strong>Weryfikować ilość współprac influencera.</strong> <br/>Twórca, który dodaje zbyt dużo postów sprzedażowych, może łatwo stracić sympatię obserwujących. Poza tym na takim kanale Twoja marka łatwo zginie w tłumie.</>,
          <><strong>Dobierać influencerów z&nbsp;myślą o&nbsp;swojej grupie docelowej.</strong> <br/>Choć jednym z&nbsp;celów współpracy jest poszerzenie grona odbiorców o całkiem nowe osoby, musisz zadbać o dotarcie do tych, którym dedykowany jest Twój produkt.</>,
          <><strong>Dać influencerom wolność.</strong> <br/>Określ jasno swoje oczekiwania i&nbsp;warunki współpracy na samym początku, ale bądź otwarty na pomysły twórcy. To często owocuje kreatywnymi, nieszablonowymi rozwiązaniami. Polecamy chaos kontrolowany. :)</>
        ]
      }
    },
    iframe:            {
      first:  {
        src: 'https://www.youtube.com/embed/vI4LHl4yFuo'
      },
      second: {
        src: "https://www.youtube.com/embed/L0YPsuZYZIY",
      }
    },
    imagesWithCaption: {
      first:    {
        img:     (
                   <Image
                     alt=""
                     objectPosition={"center"}
                     objectFit={"contain"}
                     fluid={images.img_1.childImageSharp.fluid}
                   />
                 ),
        caption: "",
        width:   600,
      },
      second:   {
        img:     (
                   <Image
                     alt=""
                     objectPosition={"center"}
                     objectFit={"contain"}
                     fluid={images.img_2.childImageSharp.fluid}
                   />
                 ),
        caption: "Źródło: https://nowymarketing.pl/a/27176,samochod-staje-sie-rowerem-a-kopalnia-elektrownia-wiatrowa-nowa-kampania-lego-pokazuje-jak-zmieniac-swiat-na-lepsze",
        width:   440,
      },
      third:    {
        img:     (
                   <Image
                     alt=""
                     objectPosition={"center"}
                     objectFit={"contain"}
                     fluid={images.img_3.childImageSharp.fluid}
                   />
                 ),
        caption: "Źródło: https://consumerculturefashion.wordpress.com/2012/03/20/rolex/#jp-carousel-142",
        width:   440,
      },
      fourth:   {
        img:     (
                   <Image
                     alt=""
                     objectPosition={"center"}
                     objectFit={"contain"}
                     fluid={images.img_4.childImageSharp.fluid}
                   />
                 ),
        caption: "",
        width:   440,
      },
      fifth:    {
        img:     (
                   <Image
                     alt=""
                     objectPosition={"center"}
                     objectFit={"contain"}
                     fluid={images.img_5.childImageSharp.fluid}
                   />
                 ),
        caption: "",
        width:   580,
      },
      sixth:    {
        img:     (
                   <Image
                     alt=""
                     objectPosition={"center"}
                     objectFit={"contain"}
                     fluid={images.img_6.childImageSharp.fluid}
                   />
                 ),
        caption: "",
        width:   580,
      },
      seventh:  {
        img:     (
                   <Image
                     alt=""
                     objectPosition={"center"}
                     objectFit={"contain"}
                     fluid={images.img_7.childImageSharp.fluid}
                   />
                 ),
        caption: "",
        width:   580,
      },
      eight:    {
        img:     (
                   <Image
                     alt=""
                     objectPosition={"center"}
                     objectFit={"contain"}
                     fluid={images.img_8.childImageSharp.fluid}
                   />
                 ),
        caption: "",
        width:   580,
      },
      ninth:    {
        img:     (
                   <Image
                     alt=""
                     objectPosition={"center"}
                     objectFit={"contain"}
                     fluid={images.img_9.childImageSharp.fluid}
                   />
                 ),
        caption: "",
        width:   580,
      },
      tenth:    {
        img:     (
                   <Image
                     alt=""
                     objectPosition={"center"}
                     objectFit={"contain"}
                     fluid={images.img_10.childImageSharp.fluid}
                   />
                 ),
        caption: "",
        width:   580,
      },
      eleventh: {
        img:     (
                   <Image
                     alt=""
                     objectPosition={"center"}
                     objectFit={"contain"}
                     fluid={images.img_11.childImageSharp.fluid}
                   />
                 ),
        caption: "",
        width:   580,
      },
    },
  };
};
